import { useCallback, useEffect, useRef } from "react";
/**
 * Usage
 * ```tsx
 * const MyComponent = () => {
 *     const elementRef = useIntersectionObserver((entry) => { ... do something ...}, options)
 *
 *     return <div ref={elementRef} />
 * }
 * ```
 * @param callback Callback gets fired everytime IntersectionObserver entry call is fired.
 * @param options Same as IntersectionObserverInit. NOTE: options are NOT reactive.
 */ export var useIntersectionObserver = function(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        rootMargin: "0px"
    }, threshold = _ref.threshold, rootMargin = _ref.rootMargin, root = _ref.root;
    var observerRef = useRef(null);
    // Always use the latest callback, without having to need to run useEffect again
    var callBackRef = useRef(callback);
    callBackRef.current = callback;
    useEffect(function() {
        return function() {
            var _observerRef_current;
            (_observerRef_current = observerRef.current) === null || _observerRef_current === void 0 ? void 0 : _observerRef_current.disconnect();
        };
    }, []);
    return useCallback(function(e) {
        var _observerRef_current;
        if (!e) {
            return;
        }
        var observer = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                callBackRef.current(entry, observer);
            });
        }, {
            rootMargin: rootMargin,
            root: root,
            threshold: threshold
        });
        (_observerRef_current = observerRef.current) === null || _observerRef_current === void 0 ? void 0 : _observerRef_current.disconnect();
        observer.observe(e);
        observerRef.current = observer;
    }, [
        root,
        rootMargin,
        threshold
    ]);
};
